import {
  AUTHENTICATING_EMAIL_REQUEST, AUTHENTICATING_EMAIL_SUCCEDDED, AUTHENTICATING_EMAIL_FAILED,
} from '../../actions/actionTypes.jsx';

import { combineReducers } from 'redux';

const initialState = {
  activating: false,
  error: null
};

function emailIntegrationReducer(state = initialState, action) {
  switch(action.type) {
    case AUTHENTICATING_EMAIL_REQUEST:
      return Object.assign({}, state, {
        ...state,
        activating: true,
        error: null
      })

    case AUTHENTICATING_EMAIL_SUCCEDDED: 
      return Object.assign({}, state, {
        ...state,
        activating: false,
        error: null
      })

    case AUTHENTICATING_EMAIL_FAILED:
      return Object.assign({}, state, {
        ...state,
        activating: false,
        error: action.payload
      })
    default: 
      return state;  
  }
}

export { emailIntegrationReducer };